import { produce } from "immer";

type StateUpdater<T> = {
	setState: (callback: (state: T) => T) => void;
};

export function createStateUpdater<TState, TKey extends keyof TState = keyof TState>(key: TKey) {
	return function (this: StateUpdater<TState>, value: TState[TKey]) {
		this.setState((state) =>
			produce(state, (draft) => {
				(draft as TState)[ key ] = value;
			})
		);
	};
}
